import React from "react";
import { Button, Dropdown, Image } from "react-bootstrap";
import { toast } from "react-toastify";
import LoadingScreen from '../../../CommonComponents/LoadingScreen';
import CheckBoxField from "../Feeds/AddFeeds/Elements/CheckboxField";
import Trigger from "./components/TrigerComponent";
import AutoModerationSidebar from "./components/SideBar";
import { defaultRules, triggers, rulesType } from "./triggers";
import { getAutoModList, getFeedlist, getNetworklist, saveRule, statusAutoModRule } from "../../../../actions/appsMoreAction";

import './AiAutoModeration.scss';
import { getInitialRoute, hideLangFilter } from "../../../../utils";
import { clickToPostHighlight, getModeration } from "../../../../actions/moderationActions";
import { connect } from "react-redux";
import { getLanguageTags } from "../../../../actions/loginActions";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "../../../CommonComponents/AssetsHelper";


let toastID = null;
class AiAutoModeration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultRules: defaultRules,
            isRuleActive: true,
            ruleName: 'Rule',
            filters: [],
            rules: [],
            rulesType: rulesType,
            ruleId: null,
            postCount: 0,
            networkList: [],
            feedList: [],
            createdRules: [],
            loading: true,
            languages : []
        }
    }

    componentDidMount() {
        this.getModList();
        this.languageTags()
    }


    languageTags=()=>{
        const {feeds} = this.props
        const feedList = feeds?.length > 0 ? feeds.map(item => item) : [];
        
        getLanguageTags(localStorage.getItem('ownerId')).then((response) => {
    
            let langs = response.data;
            let result = [];
            if(langs && langs?.length > 0){

                langs = langs.filter((lang) => {
                    if(hideLangFilter(feedList, lang.feedId)) return lang;
                });
                langs.sort((a, b) => b.count - a.count).forEach(lang => {
                    if(lang.language != ""){
                        result.push({ 'label' : lang.language , 'value' : lang.language });
                    }
                });
            }
            this.setState({ languages: result });
        }).catch(ex => {});
    }

    getModList = () => {
        const { userDetails, getTags } = this.props;
        const { userData, userTags } = userDetails;

        const wallId = localStorage.getItem('wallId');
        if (userData && Object.keys(userData).length > 0) {
            const userPlan = userData.UserPlan;
            if (!userTags) {
                getTags(userData.user.ownerId);
            }
            getNetworklist(wallId, userPlan?.planId, '4').then(resp => {
                const { responseData } = resp.data;
                this.setState({ networkList: responseData });
            }).catch(ex => { });

            getFeedlist(wallId, 0).then(resp => {
                const { responseData } = resp.data;
                this.setState({ feedList: responseData });
            }).catch(ex => { });

            getAutoModList().then(resp => {
                const { response, approval, duplicateAsset, neutralizer } = resp.data;
                if(duplicateAsset == 1){
                    defaultRules[0].value = true;
                    defaultRules[0].isRuleUsed = true;
                }else{
                    defaultRules[0].value = false;
                    defaultRules[0].isRuleUsed = false;
                }
                if(neutralizer == 1){
                    defaultRules[1].value = true;
                    defaultRules[1].isRuleUsed = true;
                }else{
                    defaultRules[1].value = false;
                    defaultRules[1].isRuleUsed = false;
                }
                if(approval == 1){
                    defaultRules[2].value = true;
                    defaultRules[2].isRuleUsed = true;
                }else{
                    defaultRules[2].value = false;
                    defaultRules[2].isRuleUsed = false;
                }
                this.setState({ createdRules: response, loading: false, ruleName: `Rule`, defaultRules: defaultRules });
            }).catch(ex => this.setState({ loading: false }));
        }
    }

    selectDefaultRule = (index) => {
        const { defaultRules } = this.state;
        const dRules = defaultRules.map((rule, rIndex) => {
            if (rIndex == index) {
                return { ...rule, value: !rule.value }
            }
            return { ...rule, value: rule.isRuleUsed ? true : false }
        });

        const selectedRule = dRules[index];
        let defaultRule = { filter: [{ name: 'Duplicate Post', value: true }], rule: [{ name: 'Private', value: true }] };
        if (selectedRule.name == 'Negativity Neutralizer :') {
            defaultRule = { filter: [{ name: 'Sentiment', value: '3' }], rule: [{ name: 'Private', value: true }] };
        } else if (selectedRule.name == 'Effortless Approval :') {
            defaultRule = { filter: [{ name: 'AI-Recommendation', value: '1' }, { name: 'Sentiment', value: '1' }], rule: [{ name: 'Public', value: true }] };
        }
        this.setState({ defaultRules: dRules, filters: [], rules: [], ruleName: selectedRule.value ? selectedRule.name.replace(":", "") : `Rule` }, selectedRule.value ? () => this.getDefaultRuleTemplate(defaultRule.filter, defaultRule.rule) : null);
    }

    getDefaultRuleTemplate = (filters, actions) => {
        let defaultTrigger = [triggers.find(trigger => trigger.name == filters[0].name)];
        let defaultAction = [rulesType.find(rule => rule.name == actions[0].name)];
        if (filters?.length > 1) {
            defaultTrigger[1] = triggers.find(trigger => trigger.name == filters[1].name);
        }
        if (actions?.length > 1) {
            defaultAction[1] = rulesType.find(rule => rule.name == actions[1].name);
        }
        for (let i = 0; i < defaultTrigger?.length; i++) {
            setTimeout(() => this.addFilter(defaultTrigger[i], filters[i].value), i * 100);
        }
        for (let i = 0; i < defaultAction?.length; i++) {
            setTimeout(() => this.addRule(defaultAction[i], actions[i].value), i * 100);
        }
    }

    addFilter = (item, updateValue = null) => {
        const { filters } = this.state;
        let value = updateValue ? updateValue : '';
        if (item.name == "Duplicate Post") {
            value = true;
        }
        this.setState({ filters: [...filters, { ...item, value: value }] }, () => this.scrolldiv(`filter-${this.state.filters?.length - 1}`))
    }

    updateFilter = (index, value) => {
        const { filters } = this.state;
        filters[index]['value'] = value;
        this.setState({ filters: filters });
    }

    removeFilter = (index) => {
        const { filters } = this.state;
        filters.splice(index, 1);
        this.setState({ filters });
    }

    addRule = (item, updateValue = null) => {
        const { rules, rulesType } = this.state;
        let value = updateValue ? updateValue : '';
        let type = rulesType;
        if (item.triggerType == 4) {
            value = true;
        }
        if (item.name == 'Delete') {
            type = [];
        }
        if (item.name == 'Assign Tag') {
            type = rulesType.filter(rule => rule.name != 'Delete');
        }
        this.setState({ rules: [...rules, { ...item, value: value }], rulesType: type })
    }

    updateRule = (index, value) => {
        const { rules } = this.state;
        rules[index]['value'] = value;
        this.setState({ rules });
    }

    removeRule = (index) => {
        const { rules } = this.state;
        rules.splice(index, 1);
        this.setState({ rules, rulesType: rulesType });
    }

    updateCreatedRule = (index, status) => {
        const createdRules = this.state.createdRules;
        createdRules[index]['status'] = status;
        this.setState({ createdRules: createdRules });
    }

    updateCreatedRuleStatus = (id, index, status) => {
        const toastID = toast.loading("Loading...", { autoClose: 3000 })
        statusAutoModRule(id, status).then(response => {
            const { ruleId, isRuleActive } = this.state;
            const { message } = response.data;
            if (ruleId) {
                this.setState({ isRuleActive: !isRuleActive })
            }
            this.updateCreatedRule(index, status);
            toast.update(toastID, {
                render: message,
                type: toast.TYPE.SUCCESS,
                autoClose: 3000
            });
            setTimeout(() => toast.dismiss(toastID), 3000);
        }).catch(ex => {
            setTimeout(() => toast.dismiss(toastID), 3000);
        })
    }

    removeCreatedRule = () => {
        getAutoModList().then(resp => {
            const { response, approval, duplicateAsset, neutralizer } = resp.data;
            if(duplicateAsset == 1){
                defaultRules[0].value = true;
                defaultRules[0].isRuleUsed = true;
            }else{
                defaultRules[0].value = false;
                defaultRules[0].isRuleUsed = false;
            }
            if(neutralizer == 1){
                defaultRules[1].value = true;
                defaultRules[1].isRuleUsed = true;
            }else{
                defaultRules[1].value = false;
                defaultRules[1].isRuleUsed = false;
            }
            if(approval == 1){
                defaultRules[2].value = true;
                defaultRules[2].isRuleUsed = true;
            }else{
                defaultRules[2].value = false;
                defaultRules[2].isRuleUsed = false;
            }


            this.setState({ createdRules: response, ruleId: null, isRuleActive: true, filters: [], rules: [], rulesType: rulesType, defaultRules: defaultRules, ruleName: `Rule` },()=>this.props.getModeration());
        }).catch(ex => { });
    }

    editRule = (rule) => {
        const { id, status, name, handle, hashtag, networks, assetsType, sentiment, recommend, feeds, duplicateAsset, keyword, tags, language, postCount } = rule;

        let filters = triggers.filter(trigger => {
            
            if (trigger.name == 'By Handle' && handle != "") {
                 trigger['value'] = handle;
                return trigger;
            } else if (trigger.name == 'By Hashtag' && hashtag != "") {
                 trigger['value'] = hashtag;
                return trigger;
            } else if (trigger.name == 'Social Network' && networks != "") {
                trigger['value'] = networks;
                return trigger;
            } else if (trigger.name == 'Media Type' && assetsType != "") {
                let value = assetsType
                if (value.includes('2,4')) {
                    value = value.replace('2,4', '2');
                }
                if (value.includes('3,5')) {
                    value = value.replace('3,5', '3');
                }
                trigger['value'] = value;
                return trigger;
            } else if (trigger.name == 'Sentiment' && sentiment != "") {
                trigger['value'] = sentiment;
                return trigger;
            } else if (trigger.name == 'AI-Recommendation' && recommend != "") {
                trigger['value'] = recommend;
                return trigger;
            } else if (trigger.name == 'By Feeds' && feeds && feeds != "") {
                trigger['value'] = feeds;
                return trigger;
            } else if (trigger.name == 'Duplicate Post' && duplicateAsset != "" && duplicateAsset) {
                trigger['value'] = duplicateAsset;
                return trigger;
            } else if (trigger.name == 'By Keyword' && keyword != "") {
                trigger['value'] = keyword;
                return trigger;
            }else if (trigger.name == 'Language' && language != "" && language) { 
                    trigger['value'] = language;
                    return trigger;
            } else if (trigger.name == 'Tags' && tags != "") {
                trigger['value'] = tags;
                return trigger;
            } 
        });

        

        let rules = [];
        let types = rulesType;
        let actions = typeof (rule.actions) == 'string' ? JSON.parse(rule.actions) : rule.actions;
        if (actions && actions?.length > 0) {
            for (let action of actions) {
                if (action.type == 4) {
                    let key = action.value == 1 ? 'Public' : 'Private';
                    const item = rulesType.find(rule => rule.name == key);
                    rules.push({ ...item, value: true });
                } else if (action.type == 3) {
                    types = rulesType.filter(rule => rule.name != 'Delete');
                    const item = rulesType.find(rule => rule.name == 'Assign Tag');
                    rules.push({ ...item, value: action.value });
                } else if (action.type == 5) {
                    types = [];
                    const item = rulesType.find(rule => rule.name == 'Delete');
                    rules.push({ ...item, value: true });
                }
            }
        }

        this.setState({ ruleId: id, postCount: postCount, isRuleActive: status, ruleName: name, filters: filters, rules: rules, rulesType: types })
    }

    createPostBody = () => {
        const { filters, rules, ruleName, isRuleActive, ruleId, postCount, createdRules } = this.state;
        const wallId = localStorage.getItem('wallId');
        const postObj = {
            id: ruleId ? ruleId : "",
            name: ruleName,
            status: isRuleActive ? 1 : 0,
            wallId: parseInt(wallId),
            postCount: postCount,
            showHide: 0,
            handle: "",
            hashtag: "",
            networks: "",
            assetsType: "",
            sentiment: "",
            recommend: "",
            feeds: "",
            duplicateAsset: 0,
            keyword: "",
            tags: "",
            language: "",
            actions: [],
            target: createdRules?.length
        }

        if (filters && filters?.length > 0) {
            filters.forEach((filter) => {
                if (filter.name == 'By Handle') {
                    postObj['handle'] = filter.value;
                } else if (filter.name == 'By Hashtag') {
                    postObj['hashtag'] = filter.value;
                } else if (filter.name == 'Social Network') {
                    postObj['networks'] = filter.value;
                } else if (filter.name == 'Media Type') {
                    if (filter.value.includes('2') && !filter.value.includes('2,4')) {
                        filter.value = filter.value.replace('2', '2,4')
                    }
                    if (filter.value.includes('3') && !filter.value.includes('3,5')) {
                        filter.value = filter.value.replace('3', '3,5')
                    }
                    postObj['assetsType'] = filter.value;
                } else if (filter.name == 'Sentiment') {
                    postObj['sentiment'] = filter.value;
                } else if (filter.name == 'AI-Recommendation') {
                    postObj['recommend'] = filter.value;
                } else if (filter.name == 'By Feeds') {
                    postObj['feeds'] = filter.value;
                } else if (filter.name == 'Duplicate Post') {
                    postObj['duplicateAsset'] = filter.value ? 1 : 0;
                } else if (filter.name == 'By Keyword') {
                    postObj['keyword'] = filter.value;
                } else if (filter.name == 'Tags') {
                    postObj['tags'] = filter.value;
                } else if (filter.name == 'Language') {
                    postObj['language'] = filter.value;
                }
            })
        }

        if (rules && rules?.length > 0) {
            let actions = [];
            rules.forEach((rule) => {
                const { type, name, value } = rule;
                if (rule.type == 4) {
                    let value = name == 'Public' ? '1' : '2';
                    actions.push({ type, value });
                } else if (rule.type == 3) {
                    actions.push({ type, value: value });
                } else if (rule.type == 5) {
                    actions.push({ type, value: "" });
                }
            })
            postObj['actions'] = actions;
        }

        return postObj;
    }

    submitRule = () => {
        if (!toastID) {
            const obj = this.createPostBody();

            const { moderation } = this.props;
            const { listData } = moderation;
            obj.postHighlightId = "0"
            if (listData && listData?.length) {
               const postHeighlight = listData.find(item => item.highlight == 1);
               if(postHeighlight)  obj.postHighlightId = String(postHeighlight.id)
            }


            if (obj.name == "" || obj.name.trim().length == 0) {
                toast.error("Please enter rule name", { autoClose: 2000 });
                return;
            }
            toastID = toast.loading("Loading...", { autoClose: 3000 })


            saveRule(obj).then((response) => {

                const { responseCode, responseMessage, isHighlight  } = response.data;
                if (responseCode == 200) {
                    toast.update(toastID, { render: responseMessage, type: toast.TYPE.SUCCESS, autoClose: 3000 });
                    getAutoModList().then(resp => {
                        const { response, approval, duplicateAsset, neutralizer } = resp.data;
                        if(duplicateAsset == 1){
                            defaultRules[0].value = true;
                            defaultRules[0].isRuleUsed = true;
                        }else{
                            defaultRules[0].value = false;
                            defaultRules[0].isRuleUsed = false;
                        }
                        if(neutralizer == 1){
                            defaultRules[1].value = true;
                            defaultRules[1].isRuleUsed = true;
                        }else{
                            defaultRules[1].value = false;
                            defaultRules[1].isRuleUsed = false;
                        }
                        if(approval == 1){
                            defaultRules[2].value = true;
                            defaultRules[2].isRuleUsed = true;
                        }else{
                            defaultRules[2].value = false;
                            defaultRules[2].isRuleUsed = false;
                        }
                        this.setState({ createdRules: response, ruleId: null, isRuleActive: true, filters: [], rules: [], rulesType: rulesType, defaultRules: defaultRules, ruleName: `Rule` },()=>this.props.getModeration());
                    }).catch(ex => { });
                }


                if(obj.postHighlightId && !isHighlight){
                    this.props.clickToPostHighlight(obj.postHighlightId, false, false, false, false, false)
                }

                setTimeout(() => { toast.dismiss(toastID); toastID = null }, 3000);
            }).catch(ex => {
                if (ex && Object.keys(ex).length > 0 && ex.response) {
                    if (ex.response && Object.keys(ex.response).length > 0 && ex.response.data) {
                        toast.update(toastID, { render: ex.response.data.responseMessage, type: toast.TYPE.ERROR, autoClose: 3000 });
                    }
                }
                setTimeout(() => { toast.dismiss(toastID); toastID = null }, 3000)
            }
            );
        }
    }

    cancelRule = (id) => {
        if (id) this.setState({ ruleName: `Rule`, ruleId: null, isRuleActive: true, filters: [], rules: [], rulesType, defaultRules });
        else this.props.closeModeration();
    }

    scrolldiv = (id) => {
        const element = document.getElementById(id);
        element.scrollIntoView({ behavior: "smooth" });
    }

    upgradePlan = (type) =>{
        const { showUpgradePop } = this.props;
        showUpgradePop(type);
    }

    componentWillUnmount(){
        localStorage.removeItem('auto-pilot')
        this.props.closeModeration();
    }

    render() {
        const { defaultRules, isRuleActive, ruleName, filters, rules, rulesType, ruleId, networkList, feedList, createdRules, loading, languages } = this.state;
        const { userData, userTags } = this.props.userDetails;
        const unUsedTriggers = triggers.filter(trigger => !filters.some(item => item.name == trigger.name));
        const unUsedActions = rulesType.filter(rule => !rules.some(item => item.triggerType == rule.triggerType));
        const isTriggerSelected = filters?.length > 0 ? filters.every(filter => filter.value != '') : false;
        const isActionSelected = rules?.length > 0 ? rules.every(rule => rule.value != '') : false;
        const ruleIndex = ruleId ? createdRules.findIndex(rule => rule.id == ruleId) : 0;
        const trueSense = userData?.user?.trueSense;

        return (<div className="moderation_modal_main auto-pilot-modal bg-white">
            {<div className='moderation_modal_inner'>
                <div className='modal-header border-bottom justify-content-between py-0 ps-0'>
                    <div className="d-flex align-items-center">
                        <Button variant="link" onClick={() => this.props.closeModeration()} className="me-3 border-end border-0 p-3 rounded-0">
                            <FontAwesomeIcon icon={'chevron-left'} iconClass={'p-0'} />
                        </Button>
                        <span className='text-dark fw-medium fs-5'>Auto Pilot</span>
                    </div>
                    <div className="ass_modal_actions">
                        <div className="d-flex align-items-center flex-wrap">
                            <Button variant="link" className="py-2 px-3" onClick={this.props.closeModeration}>
                                <FontAwesomeIcon type={'regular'} icon={'xmark'} iconClass={''} />
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="moderation_modal_action d-flex flex-wrap">
                    <div className="moderation_modal_action_left">
                        <div className="moderation_action f-between flex-column">
                            <div className="w-100">
                                <div className="trigger-main">
                                    <div className="form-group mb-3">
                                        <input type="text" className="form-control" value={ruleName} onChange={(e) => this.setState({ ruleName: e.target.value })} />
                                    </div>
                                    <div className="form-group mb-3">
                                        <div className="toggleOnBut d-flex align-items-center">
                                            <span className="switch custom-toggle">
                                                <CheckBoxField isChecked={isRuleActive} name={`auto-moderation-rule`} id={`auto-moderation-rule`} onChangeHandler={(e) => ruleId ? this.updateCreatedRuleStatus(ruleId, ruleIndex, !isRuleActive) : this.setState({ isRuleActive: !isRuleActive })} text={''} />
                                            </span> Rule Status
                                        </div>
                                    </div>

                                    {/* Filter post */}
                                    <div className="position-relative add-rule">
                                        {filters?.length == 0 ? <Dropdown className="w-100">
                                            <Dropdown.Toggle variant="" id="rule-1" className="trigger-box w-100">
                                                <FontAwesomeIcon type={'solid'} icon={'plus'} iconClass={'me-2 lh-sm'} />
                                                <span className="fs-6 fw-medium">Add Trigger</span>
                                            </Dropdown.Toggle>
                                            <TriggerList triggers={unUsedTriggers} type={'filter'} addFilter={this.addFilter} trueSenseEnable={trueSense}  upgradePlan={this.upgradePlan} />
                                        </Dropdown> : null}


                                        {filters?.length > 0 ? filters?.map((filter, index) => <>
                                            <div className="trigger-box trigger-box-card" id={`filter-${index}`}>
                                                <Trigger removeTrigger={() => this.removeFilter(index)} triggerType={filter} key={index} updateValue={this.updateFilter} triggerIndex={index} networkList={networkList} feedList={feedList} languages={languages} tags={userTags ? userTags : ''}  />
                                            </div>
                                            <div className="action_gap"></div>
                                        </>) : null}

                                        {(filters?.length > 0 && unUsedTriggers?.length > 0) ? !isTriggerSelected ? <div className="position-relative"><span className="fs-9 fw-medium btn-and btn" style={{ opacity: '0.7' }}>and</span></div> : <Dropdown className="position-relative">
                                            <Dropdown.Toggle variant="" id="rule-2" className="btn-none">
                                                <span className="fs-6 fw-medium btn-and btn text-dark">and</span>
                                            </Dropdown.Toggle>
                                            <TriggerList triggers={unUsedTriggers} type={'filter'} addFilter={this.addFilter} trueSenseEnable={trueSense} upgradePlan={this.upgradePlan} />
                                        </Dropdown> : null}
                                    </div>

                                     {/* Assign rule */}
                                    <div className="position-relative add-action">
                                        {rules?.length == 0 ? !isTriggerSelected ? <div className="trigger-box bg-transparent disable">
                                            <FontAwesomeIcon type={'solid'} icon={'plus'} iconClass={'me-2 lh-sm'} />
                                            <span className="fs-9 fw-medium">Add Action</span>
                                        </div> : <Dropdown>
                                            <Dropdown.Toggle variant="light" id="action-1" className="trigger-box w-100 bg-transparent">
                                                <FontAwesomeIcon type={'solid'} icon={'plus'} iconClass={'me-2 lh-sm'} />
                                                <span className="fs-9 fw-medium">Add Action</span>
                                            </Dropdown.Toggle>
                                           
                                            <TriggerList triggers={unUsedActions} type={'action'} addFilter={this.addRule} trueSenseEnable={trueSense}  upgradePlan={null} />
                                        </Dropdown> : rules?.map((rule, index) => <React.Fragment key={`action-${index}`}>
                                            <div className="trigger-box trigger-box-card">
                                                <Trigger removeTrigger={() => this.removeRule(index)} triggerType={rule} key={index} updateValue={this.updateRule} triggerIndex={index} networkList={networkList} feedList={feedList} languages={languages} tags={userTags ? userTags : ''} />
                                            </div>

                                            {(filters?.length > 0 && rules?.length > 0 && unUsedActions?.length > 0) ? !isTriggerSelected ? <div className="position-relative"><span className="fs-9 fw-medium btn-and btn" style={{ opacity: '0.7' }}>and</span></div> : <Dropdown className="position-relative btn-and-main">
                                                <Dropdown.Toggle variant="" id="action-2" className="btn-none">
                                                    <span className="fs-6 fw-medium btn-and btn text-dark">and</span>
                                                </Dropdown.Toggle>
                                                <TriggerList triggers={unUsedActions} type={'action'} addFilter={this.addRule} trueSenseEnable={trueSense} upgradePlan={null} />
                                            </Dropdown> : null}
                                            {!(rules?.length - 1 == index) ? !(filters?.length == 0 && rules?.length == 2 && index != 0) ? <div className="action_gap"></div> : null : null}
                                        </React.Fragment>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <p className="bg-light p-3 my-0 mx-3 rounded"><strong>Note<sup className="text-danger">*</sup>:</strong> Activation of AI-driven rules may require some processing time before taking effect. During this period, all impacted posts will be temporarily moved to a private tab. Once the rule is implemented, the expected behavior will align with the established guidelines.</p>
                                </div>
                                <div className="d-flex justify-content-end align-center p-3">
                                    <button type="button" className="btn btn-secondary me-3 btn-min-w" onClick={() => this.cancelRule(ruleId)}><span className="position-relative">Cancel</span></button>
                                    <button type="button" className={`btn btn-primary btn-min-w ${(isTriggerSelected && isActionSelected) ? '' : 'disable'}`} onClick={(isTriggerSelected && isActionSelected) ? () => this.submitRule() : null}>{ruleId ? 'Update' : 'Create'} Rule</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <AutoModerationSidebar defaultRules={defaultRules} selectDefaultRule={this.selectDefaultRule} createdRules={createdRules} removeRule={this.removeCreatedRule} updateCreatedRule={this.updateCreatedRuleStatus} updateRule={this.editRule} ruleId={ruleId} trueSenseEnable={trueSense} upgradePlan={this.upgradePlan} changeRuleOrder={(updateRules)=>this.setState({ createdRules: updateRules })}/>
                </div>
            </div>}
        </div>
        )
    }
}



const mapStateToProps = (state) => {  
    return {
        moderation: state.moderation,
        feeds: state.manageFeeds.feeds,
    }
  }

const updateModeration=(dispatch)=>{
    return{
        getModeration: () => dispatch(getModeration()),
        clickToPostHighlight: (index, spostId, id, highlight, isPopup, callback) => dispatch(clickToPostHighlight(index, spostId, id, highlight, isPopup, callback)),

    }
}

export default connect(mapStateToProps,updateModeration)(AiAutoModeration);

const TriggerList = ({ triggers, type, addFilter, trueSenseEnable, upgradePlan }) => {
    const isWidget = getInitialRoute() == 'widget';
    return <Dropdown.Menu className="p-0 trigger-list bg-white w-100 shadow rounded">{triggers.map((trigger, index) => {
        const disable = (trigger.isUpgrade && trueSenseEnable != 1);
        const upgradeType = trigger.name == 'AI-Recommendation' ? 1 : 2;

        //hide aiRecommendation in case of widget and maintaining truesense key for sentiment and recommendation depending on plan.
        const hideSection = (isWidget && type == 'filter' && trigger.name == 'AI-Recommendation') ? false : true;
        return trigger && hideSection ? <Dropdown.Item key={index} onClick={!disable ? () => addFilter(trigger) : null} id={`${type}-${index}`}>
            <div className={`f-${type == "filter" ? 'between' : 'center'} ${disable ? 'disable' : ''} w-100`}>
                {<div className="d-flex align-items-center">
                    {type == "filter" ? <div className="f-center symbol-30 rounded bg-light me-2">
                        <div className="symbol-label">
                            <Image src={trigger.icon} height="16" width="16" />
                        </div>
                    </div> : null}
                    <div className="">
                        <h6>{trigger.name}</h6>
                        {trigger.label ? <p className="mb-0 text-wrap">{trigger.label}</p> : null}
                    </div>
                </div>}
                {disable ? <div className="">
                    <Button variant="link" className="text-gradient text-nowrap" onClick={()=>upgradePlan(upgradeType)}>Upgrade Plan</Button>
                </div> : null}
            </div>
        </Dropdown.Item> : null
    })}
    </Dropdown.Menu>
}